import styles from "./index.module.css";
import FakeButton from "../../../Components/FormComponents/FakeButton";

export function Greetings({ setStart }) {
  return (
    <div className={styles.container}>
      <h1>Привіт!</h1>

      <div className={styles.description}>
        <div>
          Ми визначаємо ваших партнерів по навчанню за схожим результатом
          тестів. Розбіжність складає 3-4 бали. Будь ласка, не вгадуйте
          відповіді на тесті. Вгадування відповідей може призвести до неточного
          розподілу партнерів у групи. Якщо ви не знаєте відповіді — пропустіть
          запитання. Зміна групи за рівнем не передбачена. Якщо ви вважаєте, що
          ваш поточний рівень вище або нижче, будь ласка, напишіть нам про це на
          пошту info@profound-english.community.
        </div>
        <div>Тест містить 40 запитань.</div>
      </div>

      <div className={styles.button}>
        <FakeButton
          red
          onClick={() => {
            setStart(true);
          }}
        >
          Почати тест
        </FakeButton>
      </div>
    </div>
  );
}
